import EventViewDetails from './EventViewDetails';

export default EventViewDetails;
